import URL from '../../url'
import Request from '../../request'

/**
 *
 * @param {*} query
 */
export const paymentPatchService = content =>
  new Request(URL.API, URL.PAYMENT_PATCH + '?cardId=' + content.id).patch(content)
